// extracted by mini-css-extract-plugin
export var buttons = "subfooter-module--buttons--6e1f2";
export var contactButton = "subfooter-module--contact-button--7c1c6";
export var content = "subfooter-module--content--8b0de";
export var description = "subfooter-module--description--71a1d";
export var discordButton = "subfooter-module--discord-button--96edf";
export var subfooter = "subfooter-module--subfooter--2e1d8";